import { NotebookPen } from 'lucide-react'
import { hasNotesContent } from './NotesEditor'

type Props = {
  event: wowaudit.Event
  canEdit: boolean
  isEditing: boolean
  onStartEdit: () => void
}

const EventNotesControl = ({
  event,
  canEdit,
  isEditing,
  onStartEdit,
}: Props) => {
  if (!canEdit || isEditing || hasNotesContent(event.notes)) return null

  return (
    <button
      type='button'
      onClick={onStartEdit}
      className='group flex items-center gap-2 self-start rounded-md border border-transparent px-2 py-1 text-sm text-muted-foreground transition-colors hover:border-border hover:bg-accent'
      aria-label='Add message'
    >
      <NotebookPen className='h-3.5 w-3.5 opacity-60 transition-opacity group-hover:opacity-100' />
      <span>Add message</span>
    </button>
  )
}

export default EventNotesControl
